import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-background-200 px-4 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-foreground-500">
      <p>© {new Date().getFullYear()} LoyaltyBridge. All rights reserved.</p>
      <nav className="flex items-center gap-4" aria-label="Dashboard footer">
        <Link to="/docs" className="hover:text-foreground-950 transition-colors">API docs</Link>
        <Link to="/dashboard/settings" className="hover:text-foreground-950 transition-colors">Settings</Link>
      </nav>
    </footer>
  );
}
